import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface FileUploadProps {
  selectedFiles: File[];
  onChange: (files: File[]) => void;
  disabled?: boolean;
}

export const FileUpload: React.FC<FileUploadProps> = ({
  selectedFiles,
  onChange,
  disabled,
}) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      onChange(Array.from(e.target.files));
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="scan_photos">Scan Photos</Label>
      <Input
        id="scan_photos"
        type="file"
        multiple
        accept="image/*"
        onChange={handleFileChange}
        disabled={disabled}
      />
      {selectedFiles.length > 0 && (
        <p className="text-sm text-muted-foreground">
          {selectedFiles.length} file(s) selected
        </p>
      )}
    </div>
  );
};

